<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />
  <BlogDetail :blog-post="data?.websitePage" />
</template>

<script setup lang="ts">
import { useRouteParams } from "@vueuse/router";
import { useWebsitePageQuery } from "~/graphql/generated";

const path = useRouteParams<string>("slug");

/*
 * Fetch the blog post and handle error if not found
 */
const { data, error } = await useWebsitePageQuery({
  variables: {
    websitePage: {
      path: `/${path.value}`,
    },
  },
});

if (error?.value || !data.value?.websitePage) {
  useRouter().replace("/404");
}

/*
 * Breadcrumbs
 */
const { t } = useI18n();
// Set the breadcrumbs
const breadcrumbs = ref([
  {
    to: "/blog",
    text: t("blog.title"),
  },
  {
    to: data.value?.websitePage?.path ?? "/",
    text: data.value?.websitePage?.title ?? "",
  },
]);

/*
 * Set the page title and meta description
 */
useHead({
  title: data.value?.websitePage?.title,
  meta: [
    {
      name: "description",
      content: data.value?.websitePage?.metaDescription ?? "",
    },
  ],
});
</script>
